export default __webpack_public_path__ + "static/media/AF24CA4E-3E30-46B5-A355-BECBA2A48373_1_105_c.164fc601.jpeg";